<template>
    <div class="normal">
		  <router-view />
    </div> 
</template>
<script>
	export default {
		
		
	}
</script>

<style >
	html,body{
		
		background: #F3F4F5;
		
	}
	.normal{
		
	}
</style>